import { StatusDueDate } from '@/components/DueDate';
import { ShipmentWithRelations } from '@/models/shipment';

export const ShipmentStepDueDate = ({
  shipment,
  variant,
}: {
  shipment: ShipmentWithRelations;
  variant: 'card' | 'row';
}) => {
  if (!shipment.statusDueAt) {
    return variant === 'card' ? null : <span>-</span>;
  }

  return (
    <StatusDueDate date={new Date(shipment.statusDueAt)} variant={variant} displayDayMonthOnly />
  );
};
